import { useEffect, useState } from "react";
import { Controller, FormProvider, useForm } from "react-hook-form";
import TextInput from "../../components/Form/TextInput";
import { Button, DatePicker, Form, Input, InputNumber, Modal } from "antd";
import SelectDropdown from "../../components/Form/SelectDropdown";
import dayjs from "dayjs";
import RadioInput from "../../components/Form/Radio/RadioInput";
import { monthList } from "./UserData";
import { ReactComponent as Arrow } from "../../images/v-arrow.svg";
import FileUpload from "../../components/FileUpload/FileUploadWithThumb";
import { toast } from "react-toastify";
import axios from "../../axios/axios";
import { setFloorAppFormDeatils } from "../../redux/slice/newFloorApplication";
import { useDispatch } from "react-redux";
import moment from "moment";
import { IMAGE_BASE_URL } from "../../common/Constants";
import countryCode from "../../config/countryCode.json";
import { ConvertByteToMb } from "../../common/Constants";
import TextArea from "antd/es/input/TextArea";
import VehicleDetailsPDF from "./GeneratePdf";
import { pdf } from "@react-pdf/renderer";

const DATE_FORMAT = "DD-MM-YYYY";

const VehicleDetails = ({
  selectedOption,
  childSelectedOption,
  formValues,
  onSubmit,
  RetriveFormSubmit,
  OwnerIdData,
  retriveMessage,
  methods,
  ApplicationId,
  setIsStepCompleted,
  isStepCompleted,
  setSelectedOption,
  retriveLoading,
  DefaultFormValues,
  RetriveVehicleData,
  RetriveVehicleDetails,
  vehicleDocumnets,
  setShowStepSection
}) => {
  const dispatch = useDispatch();
  const Manually = childSelectedOption === "Manually" ? true : false;
  const [showUploadDocument, setShowUploadDocument] = useState(true);
  const [showUsedVehicle, setShowUsedVehicle] = useState(true);
  const [showVechForm, setShowVechForm] = useState(Manually);
  const [UploadDocuments, setUploadDocuments] = useState({
    logcard: [],
    additional: [],
  });
  const [isParsed, setIsParsed] = useState(false);
  const [logcardText, setLogcardText] = useState("");
  const [tempAccessCode, setTempAccessCode] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [parsedPDFData, setParsedPDFData] = useState({});
  const [vehicelDetail, setVehicleDetail] = useState({});
  const [errorModalVisible, setErrorModalVisible] = useState(false);
  const [errorMessages, setErrorMessages] = useState("");

  const {
    control,
    handleSubmit,
    register,
    formState: { errors },
    watch,
    getValues,
    setValue,
    reset,
  } = methods;

  const defaultFormValues = {
    vehicle_reg_no: '',
    access_code: '',
    ownerId_type: '',
    ownerId_last4: '',
    intended_floor_amount: null,
    purchase_price: null,
    selling_price: null,
    flooring_percentage: null,
    make_model: '',
    first_reg_date: null,
    yom: '',
    is_opc_vehicle: 0,
    COE_expiry: null,
    COE_value: null,
    OMV: null,
    engine_no: '',
    chassis_no: '',
    min_parf: null,
    parf_rebate: null,
    coe_rebate: null,
    total_rebate: null,
    is_vehicle_coe_expiry: 0,
    PQP_renewal_month: '',
    PQP_amount: null,
    logcard: [],
    additional: [],
  };

  const handleSChange = (data) => {
    let profile = { ...data };
    let obj = {};
    obj = Object.keys(profile).forEach((el) => {
      profile[el] = profile[el] === "0.00" ? "" : profile[el];
    });
    return profile;
  };

  useEffect(() => {
    const currentSellerName = watch("seller_name");
    reset({
      ...handleSChange(formValues),
      seller_name: currentSellerName,
    });
  }, [formValues]);

  useEffect(() => {
    if (
      RetriveVehicleDetails !== undefined &&
      RetriveVehicleDetails !== null &&
      Object.keys(RetriveVehicleDetails)?.length > 0
    ) {
      setVehicleDetail(RetriveVehicleDetails);
    }
  }, [RetriveVehicleDetails]);

  const intendedFloorAmount = watch("intended_floor_amount");
  const purchasePrice = watch("purchase_price");

  useEffect(() => {
    if (intendedFloorAmount && purchasePrice && purchasePrice > 0) {
      const percentage = (intendedFloorAmount / purchasePrice) * 100;
      setValue("flooring_percentage", parseFloat(percentage.toFixed(2)));
    } else {
      setValue("flooring_percentage", null);
    }
  }, [intendedFloorAmount, purchasePrice, setValue]);

  const parf = watch("parf_rebate");
  const coe = watch("coe_rebate");

  useEffect(() => {
    const calculated = Number(parf || 0) + Number(coe || 0);
    setValue("total_rebate", calculated);
  }, [parf, coe, setValue]);

  const CustomFileUpload = async ({ file, onSuccess, onError }) => {
    if (ConvertByteToMb(file.size) <= 5) {
      const formData = new FormData();
      formData.append("file[]", file);
      formData.append("module", "flooring");
      try {
        const response = await axios
          .post("/flooring/document", formData)
          .then((resp) => {
            setValue("logCard", getValues("logCard")?.concat(resp.data?.data));
            onSuccess();
          });
      } catch (error) {
        onError(error);
      }
    }
  };

  const AdditionalFileUpload = async ({ file, onSuccess, onError }) => {
    const formData = new FormData();
    formData.append("file[]", file);
    formData.append("module", "flooring");
    try {
      const response = await axios
        .post("/flooring/document", formData)
        .then((resp) => {
          setValue(
            "additional",
            getValues("additional")?.concat(resp.data?.data)
          );
          onSuccess();
        });
    } catch (error) {
      onError(error);
    }
  };

  const SubmitIncompleteForm = async (data) => {
    const dataObj = {
      vehicleInfo: {
        ...data,
        is_step1_valid: 0,
        is_draft: 1,
        flooring_product: selectedOption,
        first_reg_date:
          data[`first_reg_date`] !== "" && data[`first_reg_date`] !== null
            ? moment(data[`first_reg_date`], DATE_FORMAT).format(
              DATE_FORMAT
            ) === data[`first_reg_date`]
              ? data["first_reg_date"]
              : moment(data[[`first_reg_date`]])?.format("DD-MM-YYYY")
            : "",
        [`COE_expiry`]:
          data[`COE_expiry`] !== "" && data[`COE_expiry`] !== null
            ? moment(data[`COE_expiry`], DATE_FORMAT).format(DATE_FORMAT) ===
              data[`COE_expiry`]
              ? data["COE_expiry"]
              : moment(data[[`COE_expiry`]])?.format("DD-MM-YYYY")
            : "",
        [`COE_value`]: data[[`COE_value`]],
      },
      logcard: data.logCard,
      additional: data?.additional,
    };
    const resp = await axios.post(
      `flooring/application/update/${ApplicationId}`,
      dataObj
    );
    if (resp.status < 400) {
      toast.success(resp.data?.message);
      setIsStepCompleted({
        ...isStepCompleted,
        1: false,
      });
      dispatch(
        setFloorAppFormDeatils({
          isStepCompleted: {
            ...isStepCompleted,
            1: false,
          },
          vehicleInfo: getValues(),
        })
      );
    }
  };

  const tempSubmit = (Err) => {
    const temp = getValues();
    delete temp.id;
    delete temp.application_uniqueId;
    delete temp?.fillup_type;

    if (
      Object.values(temp)?.filter(
        (it) => it !== "" && it !== null && it !== undefined
      )?.length >=
      Number(`${watch("is_vehicle_coe_expiry") == 2 ? 24 : 22} `) &&
      watch("logCard")?.length > 0
    ) {
      onSubmit(getValues(), 1);
    } else {
      SubmitIncompleteForm(getValues());
    }
  };

  const ChangeFillupType = () => {
    setSelectedOption({
      form: selectedOption,
      fillUpType: "Manually",
    });
  };

  useEffect(() => {
    setShowVechForm(Manually);
  }, [Manually]);

  const GetFilesFormatted = (files) => {
    return files?.length > 0
      ? files?.map((url, idx) => {
        return {
          uid: idx + 1,
          name: url.name ? url.name : "Document",
          status: "done",
          url: `${IMAGE_BASE_URL}/${url.path}`,
        };
      })
      : [];
  };
  const temp = getValues();
  delete temp.id;
  delete temp.application_uniqueId;
  delete temp?.fillup_type;
  useEffect(() => {
  }, [watch()]);

  const OnClear = () => {
    reset(DefaultFormValues);
  };

  const parseLogcardText = async (text) => {
    const newParsedData = {};

    const knownSectionHeaders = [
      "Vehicle Owner Particulars",
      "Vehicle Details",
      "Vehicle to be Exported",
      "Intended Deregistration Date",
      "Intended PARF Rebate Details",
      "Intended COE Rebate Details",
      "Message",
      "OPC Cash Rebate Details",
    ];

    const extractValue = (line) => {
      const match = line.match(/:\s*(.*)/);
      return match ? match[1].trim() : line.trim();
    };

    const fieldsMap = [
      { label: /Vehicle No\./i, field: "vehicle_reg_no" },
      { label: /Owner ID Type/i, field: "ownerId_type" },
      { label: /Owner ID$/i, field: "ownerId_last4" },
      { label: /Vehicle Make/i, field: "make_model" },
      { label: /Vehicle Model/i, field: "make_model" },
      { label: /Primary Colour/i, field: "vehicle_color" },
      { label: /Manufacturing Year/i, field: "yom" },
      { label: /Engine No\./i, field: "engine_no" },
      { label: /Chassis No\./i, field: "chassis_no" },
      { label: /Open Market Value/i, field: "OMV" },
      { label: /Original Registration Date/i, field: "first_reg_date" },
      { label: /First Registration Date/i, field: "first_reg_date" },
      { label: /COE Expiry Date/i, field: "COE_expiry" },
      { label: /^QP Paid$/i, field: "vehicle_coe_amount" },
      { label: /^PQP Paid$/i, field: "vehicle_pqp_paid_amount" },
      { label: /COE-QP \/ PQP Paid|QP Paid/i, field: 'COE_value' },
      { label: /COE Category/i, field: "vehicle_coe_category" },
      { label: /Transfer Count/i, field: "transfer_count" },
      { label: /Actual ARF Paid/i, field: "min_parf" },
      { label: /PARF Rebate Amount/i, field: "parf_rebate" },
      { label: /COE Rebate Amount/i, field: "coe_rebate" },
      { label: /Total Rebate Amount/i, field: "total_rebate" },
      { label: /Selling Price/i, field: 'selling_price' },
      { label: /Access Code/i, field: 'access_code' },
      { label: /Flooring Percentage/i, field: 'flooring_percentage' },
    ];

    const lines = text.split(/\r?\n/);
    for (let i = 0; i < lines.length; i++) {
      const line = lines[i].trim();
      for (const { label, field } of fieldsMap) {
        if (label.test(line)) {
          let value = extractValue(line);
          if (!value && i + 1 < lines.length) {
            const nextLine = lines[i + 1].trim();
            const isLabel = fieldsMap.some((f) => f.label.test(nextLine));
            const isSection = knownSectionHeaders.includes(nextLine);

            if (!isLabel && !isSection) {
              value = extractValue(nextLine);
              i++;
            }
          }

          if (value) {
            newParsedData[field] = value.replace(/[$,]/g, "").trim();
          }
        }
      }
    }
    const fieldMap = {
      "Owner ID Type": "customer_id_type",
      "Owner ID": "owner_id",
      "Vehicle No.": "vehicle_reg_no",
      "Vehicle to be Exported": "is_vehicle_exported",
      "Intended Deregistration Date": "intended_reg_date",
      "Vehicle Make": "vehicle_make",
      "Vehicle Model": "make_model",
      "Primary Colour": "vehicle_color",
      "Manufacturing Year": "vehicle_yom",
      "Engine No.": "vehicle_engine_no",
      "Chassis No.": "vehicle_chassis_no",
      "Maximum Power Output": "maximum_power",
      "Open Market Value": "vehicle_omv",
      "Original Registration Date": "vehicle_ori_reg_date",
      "First Registration Date": "vehicle_first_reg_date",
      "Transfer Count": "transfer_count",
      "Actual ARF Paid": "arf_paid",

      "OPC": "vehicle_opc",

      "PARF Eligibility": "parf_eligibility",
      "PARF Eligibility Expiry Date": "parf_eligibility_expiry_date",
      "PARF Rebate Amount": "parf_rebate",

      "COE Rebate Amount": "coe_rebate",
      "QP Paid": "vehicle_coe_amount",
      "PQP Paid": "vehicle_pqp_paid_amount",
      "COE Category": "vehicle_coe_category",
      "COE Expiry Date": "coe_expiry_date",
      "COE Period(Years)": "vehicle_coe_periods",
      // "OPC Cash Rebate Amount": "opc_rebate",
      // "OPC Cash Rebate Eligibility Expiry Date": "opc_eligibility_expiry_date",
      "Total Rebate Amount": "total_rebate",

    };
    for (let i = 0; i < lines.length; i++) {
      const line = lines[i].trim();
      const [rawKey, ...rest] = line.split(":");
      const key = rawKey.trim();
      const value = rest.join(":").trim();

      if (fieldMap.hasOwnProperty(key)) {
        const fieldKey = fieldMap[key];
        const cleanedValue = value.replace(/[$,]/g, "");
        newParsedData[fieldKey] = cleanedValue;
      }
    }


    //Search OPC
    const opcSearch = text.toUpperCase().includes("OPC");
    setValue("is_opc_vehicle", opcSearch ? 1 : 0);

    //for parf validate 
    const qpPaid = newParsedData.vehicle_coe_amount;
    const pqpPaid = newParsedData.vehicle_pqp_paid_amount;
    const orgDate = newParsedData.vehicle_ori_reg_date
    const firstDate = newParsedData.vehicle_first_reg_date

    const formAccessCode = getValues('access_code');
    const mergedData = {
      ...newParsedData,
      access_code: formAccessCode,
    };
    Object.entries(mergedData).forEach(([field, value]) => {
      setValue(field, value, { shouldValidate: true, shouldDirty: true });
    });

    const validateVehicle = () => {
      const validationErrors = [];
      if (selectedOption === "PARF") {
        if (orgDate === firstDate && qpPaid) {
          toast.success("You have selected a PARF vehicle.");
        } else if (orgDate === firstDate && pqpPaid) {
          validationErrors.push("PARF validation failed. Conditions not satisfied.");
        }
      } else if (selectedOption === "COE") {
        if (orgDate === firstDate && pqpPaid) {
          toast.success("You have selected a COE vehicle.");
        } else if (orgDate === firstDate && qpPaid) {
          validationErrors.push("COE validation failed. Conditions not satisfied.");
        }
      } else {
        validationErrors.push("Invalid vehicle type selected.");
      }
      return validationErrors;
    };
    const errors = validateVehicle();
    if (errors.length > 0) {
      console.log("error found");
      let currentTag = null;
      if (selectedOption === 'PARF') {
        currentTag = 'COE';
      } else {
        currentTag = 'PARF';
      }
      setErrorMessages(
        "The selected loan product is under the " + selectedOption +
        " category, but the uploaded log card details are for the " +
        currentTag +
        " category. Please re-select the correct loan product or upload the proper log card details."
      );
      setErrorModalVisible(true);
    }

    if (errors.length === 0) {
      const blob = await pdf(<VehicleDetailsPDF data={mergedData} isOPC={opcSearch} />).toBlob();
      const fileName = mergedData.vehicle_reg_no + '.pdf';
      const file = new File([blob], fileName, { type: 'application/pdf' });
      mergedData.file = file;
      setParsedPDFData(mergedData);
      RetriveVehicleData(mergedData);
      setIsParsed(true);
    }
    localStorage.setItem('vehicleRawText', text);
    localStorage.setItem('logcardParsed', 'true');
  };

  //localstorage - GET
  useEffect(() => {
    const fromBack = sessionStorage.getItem('fromBackButton');
    const getData = localStorage.getItem('vehicleRawText');
    const parsedFlag = localStorage.getItem('logcardParsed');
    if (fromBack === 'true') {
      if (getData) {
        setLogcardText(getData);
      }
      if (parsedFlag === 'true') {
        setIsParsed(true);
      }
      sessionStorage.removeItem('fromBackButton');
    }
  }, []);

  const validateAccessCode = () => {
    const accessCodeValue = watch("access_code")?.trim();
    if (!accessCodeValue) {
      setTempAccessCode("");
      setModalMessage("Access Code is required!");
      setIsModalVisible(true);
      return false;
    }
    return true;
  };

  const handleRedo = () => {
    setIsParsed(false);
    const currentSellerName = watch("seller_name");
    reset(defaultFormValues);
    setValue("seller_name", currentSellerName);
    setUploadDocuments({ logcard: [], additional: [] });
    setValue("logCard", []);
    setValue("additional", []);
  };

  return (
    <>
      <>
        {/* Access code */}
        <Modal
          open={isModalVisible}
          onOk={() => setIsModalVisible(false)}
          onCancel={() => setIsModalVisible(false)}
          okText="Close"
          cancelButtonProps={{ style: { display: "none" } }}
          width={500}
          centered
          footer={
            <div className="flex justify-between items-center gap-3">
              <Controller
                control={control}
                name="access_code"
                rules={{
                  required: true,
                }}
                render={({ field, fieldState }) => (
                  <Input
                    className="input-w-common"
                    placeholder="Enter an access code"
                    value={tempAccessCode}
                    onChange={(e) => setTempAccessCode(e.target.value)}
                  />
                )}
              />
              <Button
                className="!w-[100px]"
                type="primary"
                onClick={() => {
                  if (!tempAccessCode.trim()) return;
                  setValue("access_code", tempAccessCode);
                  setIsModalVisible(false);
                  parseLogcardText(logcardText);
                }}
              >
                Extract
              </Button>
            </div>
          }
        >
          <p style={{ color: 'red' }}>{modalMessage}</p>
        </Modal>
        {/* validation */}
        <Modal
          open={errorModalVisible}
          title="Validation Errors"
          centered
          onOk={() => setErrorModalVisible(false)}
          onCancel={() => setErrorModalVisible(false)}
          okText="Close"
          cancelButtonProps={{ style: { display: 'none' } }}
          width={500}
          footer={
            <div className="flex justify-center gap-3">
              <Button
                addClass="primary"
                onClick={() => {
                  setErrorModalVisible(false);
                  reset();
                  setLogcardText('');
                  setIsParsed(false);
                }}
              >
                Upload again
              </Button>
              <Button
                addClass="primary"
                onClick={() => {
                  setErrorModalVisible(false);
                  dispatch(
                    setFloorAppFormDeatils({
                      showStepSection: false,
                    })
                  );
                  setIsParsed(false);
                  setLogcardText('');
                  setShowStepSection(false);
                  reset(defaultFormValues);
                  
                  setUploadDocuments({ logcard: [], additional: [] });
                  setValue("logCard", []);
                  setValue("additional", []);
                }
                }
              >
                Re-select loan product
              </Button>
            </div>
          }
        >
          <ul className="flex flex-wrap gap-4 text-red-600 list-none p-0 m-0">
            <li className="inline-block">
              {errorMessages}
            </li>
          </ul>
        </Modal >
      </>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(tempSubmit)}>
          {/* seller details */}
          <h2 className="clear-menu-block">
            Seller Details
            {/* <span
              className="clear-menu"
              onClick={() => {
                OnClear();
              }}
            >
              Clear
            </span> */}
          </h2>
          <Controller
            name="seller_name"
            control={control}
            rules={{ required: "Seller name is required" }}
            render={({ field, fieldState }) => (
              <TextInput
                label="Seller Name"
                type="text"
                error={fieldState?.invalid ? "error" : null}
                placeholder="Enter a seller name"
                {...field}
                className="w-full md:max-w-[720px]"
              />
            )}
          />

          {retriveMessage?.message !== "" && !Manually && (
            <>
              <div className="max-w-[680px] mb-5 display-flex">
                {/* <p className="text-primary text-center">
                {retriveMessage?.message}
              </p> */}
                <p className="text-center">
                  Do you wish to fill the form manually{" "}
                  <p
                    className="text-primary text-center cursor-pointer text-decoration-line: underline"
                    onClick={() => {
                      ChangeFillupType();
                    }}
                  >
                    {" "}
                    Click here
                  </p>
                </p>
              </div>
            </>
          )}
          {/* used vehicle */}
          {showVechForm && (
            <div className="clear-menu-block">
              <div
                onClick={() => setShowUsedVehicle(!showUsedVehicle)}
                className="arrow-icon-block"
              >
                <span className={`${showUsedVehicle ? null : "down-arrow"}`}>
                  <Arrow />
                </span>
                Used Vehicle ({selectedOption})
              </div>
            </div>
          )}
          {showUsedVehicle && showVechForm ? (
            <>
              <div className="input-group w-full md:w-[730px]">
                {!isParsed ? (
                  <>
                    <label>Logcard Text Content</label>
                    <Form.Item className="mt-1">
                      <TextArea
                        rows={8}
                        value={logcardText}
                        onChange={(e) => setLogcardText(e.target.value)}
                        placeholder="Paste full Logcard text here..."
                      />
                    </Form.Item>
                    <div className='applying-loan-btn-block'>
                      <Button
                        type="button"
                        className="sav_btn mt-2 ml-auto flex"
                        onClick={() => {
                          if (!validateAccessCode()) return;
                          parseLogcardText(logcardText)
                        }}
                        disabled={logcardText.trim() === ''}
                      >
                        Extract
                      </Button>
                    </div>
                  </>
                ) : (
                  <div className="text-center mt-4">
                    <p className="text-green-600 font-semibold">
                      The data has been processed successfully. If you wish to redo it, please click here
                    </p>

                    <div className='flex justify-center mt-2'>

                      <Button onClick={handleRedo}
                        type="button"
                        className="sav_btn"
                      >
                        Redo
                      </Button>
                    </div>
                  </div>
                )}
              </div>
              <div className="input-one-line">
                <Controller
                  name="vehicle_reg_no"
                  control={control}
                  rules={{
                    required: "Vehicle reg no is required",
                  }}
                  render={({ field, fieldState }) => (
                    <TextInput
                      label="Vehicle Reg No."
                      type="text"
                      error={fieldState?.invalid ? "error" : null}
                      name={field.name}
                      placeholder="Enter a vehicle reg no"
                      onChange={(e) => field.onChange(e.target.value)}
                      value={field.value}
                      register={register}
                      className="w-full md:w-[230px]"
                      maxLength={8}
                    />
                  )}
                />
                <Controller
                  name="access_code"
                  control={control}
                  rules={{
                    required: "Access Code is required",
                  }}
                  render={({ field, fieldState }) => (
                    <TextInput
                      label="Access Code"
                      type="text"
                      error={fieldState?.invalid ? "error" : null}
                      name={field.name}
                      placeholder="Enter a access code"
                      onChange={(e) => field.onChange(e.target.value)}
                      value={field.value}
                      register={register}
                      className="w-full md:w-[230px]"
                      maxLength={8}
                    />
                  )}
                />

              </div>

              <div className="input-one-line">
                <Controller
                  control={control}
                  name="intended_floor_amount"
                  rules={{
                    required: true,
                  }}
                  render={({ field, fieldState }) => {
                    return (
                      <div className="input-group">
                        <label>Intended Floor Amount</label>
                        <InputNumber
                          type="number"
                          prefix="$"
                          name={field.name}
                          ref={field.ref}
                          value={field.value}
                          status={fieldState?.invalid ? "error" : null}
                          prefixCls="sign_Icon"
                          placeholder="0.00"
                          precision={2}
                          step="0.01"
                          className="!w-full cusAdmInputNumber2"
                          onChange={(val) => field.onChange(val)}
                        />
                      </div>
                    );
                  }}
                />
                <Controller
                  control={control}
                  name="purchase_price"
                  rules={{
                    required: true,
                  }}
                  render={({ field, fieldState }) => {
                    return (
                      <div className="input-group">
                        <label>Purchase Price</label>
                        <InputNumber
                          type="number"
                          prefix="$"
                          name={field.name}
                          ref={field.ref}
                          value={field.value}
                          status={fieldState?.invalid ? "error" : null}
                          prefixCls="sign_Icon"
                          placeholder="0.00"
                          precision={2}
                          step="0.01"
                          className="!w-full cusAdmInputNumber2"
                          onChange={(val) => field.onChange(val)}
                        />
                      </div>
                    );
                  }}
                />
                <Controller
                  control={control}
                  name="flooring_percentage"
                  rules={{
                    required: true,
                  }}
                  render={({ field, fieldState }) => {
                    return (
                      <div className="input-group">
                        <label>Flooring Percentage</label>
                        <InputNumber
                          type="number"
                          suffix={"%"}
                          name={field.name}
                          ref={field.ref}
                          value={field.value}
                          status={fieldState?.invalid ? "error" : null}
                          prefixCls="sign_Icon"
                          placeholder="0.00"
                          precision={2}
                          step="0.01"
                          className="!w-full cusAdmInputNumber2"
                          disabled={true}
                          parser={(val) => parseFloat(val).toFixed(2)}
                        // onChange={(val) => field.onChange(val)}
                        />
                      </div>
                    );
                  }}
                />
              </div>
              <Controller
                name="make_model"
                control={control}
                rules={{
                  required: "Make/Model is required",
                }}
                render={({ field, fieldState }) => (
                  <TextInput
                    label="Make/Model"
                    type="text"
                    name={field.name}
                    error={fieldState?.invalid ? "error" : null}
                    placeholder="Enter a Make/Model"
                    onChange={(e) => field.onChange(e.target.value)}
                    value={field.value}
                    register={register}
                    className="w-full md:max-w-[720px]"
                  />
                )}
              />

              <div className="input-one-line">
                <Controller
                  control={control}
                  name="first_reg_date"
                  rules={{
                    required: true,
                  }}
                  render={({ field, fieldState }) => {
                    return (
                      <div className="input-group">
                        <label>First Reg Date</label>
                        <DatePicker
                          placeholder="DD-MM-YYYY"
                          status={fieldState?.invalid ? "error" : null}
                          name={field.name}
                          ref={field.ref}
                          format={"DD-MM-YYYY"}
                          className={`py-[8px] w-full md:w-[230px]`}
                          value={
                            field.value !== undefined &&
                              field.value !== "" &&
                              field.value !== null
                              ? dayjs(field.value).isValid()
                                ? dayjs(field.value)
                                : typeof field.value === "number"
                                  ? field.value
                                  : dayjs(
                                    field.value.split("-").reverse().join("-")
                                  )
                              : null
                          }
                          onChange={(date) => {
                            field.onChange(date !== null ? date.valueOf() : "");
                          }}
                        />
                      </div>
                    );
                  }}
                />
                <Controller
                  name="yom"
                  control={control}
                  rules={{
                    required: "Chassis no is required",
                  }}
                  render={({ field, fieldState }) => (
                    <TextInput
                      label="Y.O.M"
                      type="text"
                      name={field.name}
                      error={fieldState?.invalid ? "error" : null}
                      placeholder="2018"
                      onChange={(e) => field.onChange(e.target.value)}
                      value={field.value}
                      register={register}
                      className="w-[60px]"
                    />
                  )}
                />
                <div className="radio-input-block">
                  <label className="heading-label">Is this an OPC Vehicle?</label>
                  <Controller
                    name="is_opc_vehicle"
                    control={control}
                    rules={{
                      required: "Please Select an option",
                    }}
                    render={({ field, fieldState }) => (
                      <div className="radio-input-list">
                        <RadioInput
                          name="options"
                          value="0"
                          checked={watch("is_opc_vehicle") == 0}
                          onChange={(e) => {
                            setValue("is_opc_vehicle", 0);
                          }}
                          label="No"
                        />
                        <RadioInput
                          name="options"
                          value="1"
                          checked={watch("is_opc_vehicle") == 1}
                          onChange={(e) => {
                            setValue("is_opc_vehicle", 1);
                          }}
                          label="Yes"
                        />
                      </div>
                    )}
                  />
                </div>
              </div>
              <div className="input-one-line">
                <Controller
                  control={control}
                  name={`COE_expiry`}
                  rules={{
                    required: true,
                  }}
                  render={({ field, fieldState }) => {
                    return (
                      <div className="input-group">
                        <label>COE Expiry</label>
                        <DatePicker
                          placeholder="DD-MM-YYYY"
                          status={fieldState?.invalid ? "error" : null}
                          name={field.name}
                          ref={field.ref}
                          format={"DD-MM-YYYY"}
                          className={`py-[8px] w-full md:w-[230px]`}
                          value={
                            field.value !== undefined &&
                              field.value !== "" &&
                              field.value !== null
                              ? dayjs(field.value).isValid()
                                ? dayjs(field.value)
                                : typeof field.value === "number"
                                  ? field.value
                                  : dayjs(
                                    field.value.split("-").reverse().join("-")
                                  )
                              : null
                          }
                          onChange={(date) => {
                            field.onChange(date !== null ? date.valueOf() : "");
                          }}
                        />
                      </div>
                    );
                  }}
                />
                <Controller
                  control={control}
                  name={`COE_value`}
                  rules={{
                    required: true,
                  }}
                  render={({ field, fieldState }) => {
                    return (
                      <div className="input-group">
                        <label>COE-QP / PQP Paid</label>
                        <InputNumber
                          type="number"
                          prefix="$"
                          name={field.name}
                          ref={field.ref}
                          value={field.value}
                          status={fieldState?.invalid ? "error" : null}
                          prefixCls="sign_Icon"
                          placeholder="0.00"
                          precision={2}
                          step="0.01"
                          className="!w-full cusAdmInputNumber2"
                          onChange={(val) => field.onChange(val)}
                        />
                      </div>
                    );
                  }}
                />
                <Controller
                  control={control}
                  name="OMV"
                  rules={{
                    required: true,
                  }}
                  render={({ field, fieldState }) => {
                    return (
                      <div className="input-group">
                        <label>OMV</label>
                        <InputNumber
                          type="number"
                          prefix="$"
                          name={field.name}
                          ref={field.ref}
                          value={Number(field.value)}
                          status={fieldState?.invalid ? "error" : null}
                          prefixCls="sign_Icon"
                          placeholder="0.00"
                          precision={2}
                          step="0.01"
                          className="!w-full cusAdmInputNumber2"
                          onChange={(val) => field.onChange(val)}
                        />
                      </div>
                    );
                  }}
                />
              </div>
              <div className="input-one-line">
                <Controller
                  name="engine_no"
                  control={control}
                  rules={{
                    required: "Engine no is required",
                  }}
                  render={({ field, fieldState }) => (
                    <TextInput
                      label="Engine No."
                      type="text"
                      name={field.name}
                      error={fieldState?.invalid ? "error" : null}
                      placeholder="Enter a engine no"
                      onChange={(e) => field.onChange(e.target.value)}
                      value={field.value}
                      register={register}
                      className="w-full md:w-[230px]"
                    />
                  )}
                />
                <Controller
                  name="chassis_no"
                  control={control}
                  rules={{
                    required: "Chassis no is required",
                  }}
                  render={({ field, fieldState }) => (
                    <TextInput
                      label="Chassis No."
                      type="text"
                      name={field.name}
                      error={fieldState?.invalid ? "error" : null}
                      placeholder="Enter a chassis no"
                      onChange={(e) => field.onChange(e.target.value)}
                      value={field.value}
                      register={register}
                      className="w-full md:w-[230px]"
                    />
                  )}
                />
                <Controller
                  control={control}
                  name="min_parf"
                  rules={{
                    required: true,
                  }}
                  render={({ field, fieldState }) => {
                    return (
                      <div className="input-group">
                        <label> ARF Paid</label>
                        <InputNumber
                          type="number"
                          prefix="$"
                          name={field.name}
                          ref={field.ref}
                          value={field.value}
                          status={fieldState?.invalid ? "error" : null}
                          prefixCls="sign_Icon"
                          placeholder="0.00"
                          precision={2}
                          step="0.01"
                          className="!w-full cusAdmInputNumber2"
                          onChange={(val) => field.onChange(val)}
                        />
                      </div>
                    );
                  }}
                />
              </div>
              <div className="input-one-line">
                <Controller
                  control={control}
                  name="parf_rebate"
                  rules={{
                    required: true,
                  }}
                  render={({ field, fieldState }) => {
                    return (
                      <div className="input-group">
                        <label>PARF Rebate:</label>
                        <InputNumber
                          type="number"
                          prefix="$"
                          name={field.name}
                          ref={field.ref}
                          value={field.value}
                          status={fieldState?.invalid ? "error" : null}
                          prefixCls="sign_Icon"
                          placeholder="0.00"
                          precision={2}
                          step="0.01"
                          className="!w-full cusAdmInputNumber2"
                          onChange={(val) => {
                            setValue("total_rebate", Number(val) + Number(getValues('coe_rebate')))
                            field.onChange(val)

                          }}
                        />
                      </div>
                    );
                  }}
                />
                <Controller
                  control={control}
                  name="coe_rebate"
                  rules={{
                    required: true,
                  }}
                  render={({ field, fieldState }) => {
                    return (
                      <div className="input-group">
                        <label>COE Rebate:</label>
                        <InputNumber
                          type="number"
                          prefix="$"
                          name={field.name}
                          ref={field.ref}
                          value={field.value}
                          status={fieldState?.invalid ? "error" : null}
                          prefixCls="sign_Icon"
                          placeholder="0.00"
                          precision={2}
                          step="0.01"
                          className="!w-full cusAdmInputNumber2"
                          onChange={(val) => {
                            setValue("total_rebate", Number(getValues('parf_rebate')) + Number(val))
                            field.onChange(val)
                          }
                          }
                        />
                      </div>
                    );
                  }}
                />
                <Controller
                  control={control}
                  name="total_rebate"
                  rules={{ required: true }}
                  render={({ field, fieldState }) => (
                    <div className="input-group">
                      <label>Total Rebate:</label>
                      <InputNumber
                        {...field}
                        value={Number(parf || 0) + Number(coe || 0)} // UI display
                        prefix="$"
                        status={fieldState?.invalid ? "error" : null}
                        prefixCls="sign_Icon"
                        placeholder="0.00"
                        precision={2}
                        step="0.01"
                        disabled
                        className="!w-full cusAdmInputNumber2"
                      />
                    </div>
                  )}
                />
              </div>
              <div className="radio-input-block">
                <label className="heading-label">
                  Is the Vehicle COE expiring?
                </label>
                <Controller
                  name="is_vehicle_coe_expiry"
                  control={control}
                  rules={{
                    required: "Please Select an option",
                  }}
                  render={({ field, fieldState }) => (
                    <div className="radio-input-list">
                      <RadioInput
                        name={`COE_options`}
                        value="0"
                        checked={watch("is_vehicle_coe_expiry") == 0}
                        onChange={(e) => {
                          setValue("is_vehicle_coe_expiry", 0);
                          setValue("PQP_renewal_month", "");
                          setValue("PQP_amount", "");
                        }}
                        label="No"
                      />
                      <RadioInput
                        name={`COE_options`}
                        value="1"
                        checked={watch("is_vehicle_coe_expiry") == 1}
                        onChange={(e) => {
                          setValue("is_vehicle_coe_expiry", 1);
                          setValue("PQP_renewal_month", "");
                          setValue("PQP_amount", "");
                        }}
                        label={`Yes, Floor until COE Expiry (No COE renewal needed)`}
                      />

                      <div>
                        <RadioInput
                          name={`${selectedOption}_options`}
                          value="2"
                          checked={watch("is_vehicle_coe_expiry") == 2}
                          onChange={(e) => {
                            setValue("is_vehicle_coe_expiry", 2);
                          }}
                          label={`Yes, Floor together with COE renewal`}
                        />
                      </div>
                    </div>
                  )}
                />
              </div>
              {watch('is_vehicle_coe_expiry') == 2 ? (
                <div className='pqp-block-section'>
                  <Controller
                    name='PQP_renewal_month'
                    control={control}
                    rules={{
                      required: watch('is_vehicle_coe_expiry') == 2,
                    }}
                    render={({ field, fieldState }) => {
                      return (
                        <SelectDropdown
                          label='PQP Renewal Month'
                          name={field.name}
                          errors={
                            errors?.PQP_renewal_month !== undefined
                              ? 'error'
                              : null
                          }
                          placeholder='Select a month'
                          options={monthList}
                          value={field.value}
                          onChange={(e) => field.onChange(e.target.value)}
                          className='w-full md:w-[230px]'
                          register={register}
                        />
                      );
                    }}
                  />
                  <Controller
                    control={control}
                    name='PQP_amount'
                    rules={{
                      required: watch('is_vehicle_coe_expiry') == 2,
                    }}
                    render={({ field, fieldState }) => {
                      return (
                        <div className='input-group'>
                          <label>PQP Amount</label>
                          <InputNumber
                            type='number'
                            prefix='$'
                            name={field.name}
                            ref={field.ref}
                            value={field.value}
                            status={fieldState?.invalid ? 'error' : null}
                            prefixCls='sign_Icon'
                            placeholder='000.00'
                            precision={2}
                            step='0.01'
                            className='!w-full cusAdmInputNumber2'
                            onChange={(val) => field.onChange(val)}
                          />
                        </div>
                      );
                    }}
                  />
                </div>
              ) : null}
            </>
          ) : null}
          {/* uploaddocument */}
          {showVechForm && (
            <div className="clear-menu-block">
              <div
                onClick={() => setShowUploadDocument(!showUploadDocument)}
                className="arrow-icon-block"
              >
                <span className={`${showUploadDocument ? null : "down-arrow"}`}>
                  <Arrow />
                </span>
                Upload Document(s)
              </div>
              <span
                className="clear-menu"
                onClick={() => {
                  reset({
                    ...getValues(),
                    logCard: [],
                    additional: [],
                  });
                }}
              >
                Clear
              </span>
            </div>
          )}
          {showUploadDocument && showVechForm ? (
            <div className="upload-document-section">
              <Controller
                name="logCard"
                control={control}
                rules={{
                  required: false,
                }}
                render={({ field, fieldState }) => (
                  < FileUpload
                    action="your_upload_action_url"
                    label="Logcard"
                    files={
                      field.value?.length > 0
                        ? GetFilesFormatted(field.value)
                        : []
                    }
                    //files={GetFilesFormatted(vehicleDocumnets?.log_card)}
                    onFileUpload={(fileList) => {
                      setUploadDocuments({
                        ...UploadDocuments,
                        logcard: fileList,
                      });
                    }}
                    maxCount={6}
                    CustomFileUpload={CustomFileUpload}
                    onRemove={(file) => {
                      setValue(
                        "logCard",
                        getValues("logCard")?.filter(
                          (it) => it?.name !== file?.name
                        )
                      );
                    }}
                    vehicleDocumnets={vehicleDocumnets}
                  />
                )}
              />
              <Controller
                name="additional"
                control={control}
                rules={{
                  required: false,
                }}
                render={({ field, fieldState }) => (
                  <FileUpload
                    action="your_upload_action_url"
                    label="Additional Document(s)"
                    files={
                      field.value?.length > 0
                        ? GetFilesFormatted(field.value)
                        : []
                    }
                    onFileUpload={(fileList) => {
                      setUploadDocuments({
                        ...UploadDocuments,
                        additional: fileList,
                      });
                    }}
                    maxCount={2}
                    CustomFileUpload={AdditionalFileUpload}
                    onRemove={(file) => {
                      setValue(
                        "additional",
                        getValues("additional")?.filter(
                          (it) => it?.name !== file?.name
                        )
                      );
                    }}
                  />
                )}
              />
            </div>
          ) : null}

          {showVechForm && (
            <button
              className="sav_btn -mb-[60px] mt-6 z-10 relative"
              type="submit"
              onClick={() => {
                const temp = getValues();
                delete temp.id;
                delete temp.application_uniqueId;
                delete temp?.fillup_type;

                if (
                  Object.values(temp)?.filter(
                    (it) => it !== "" && it !== null && it !== undefined
                  )?.length <
                  Number(`${watch("is_vehicle_coe_expiry") == 2 ? 24 : 22}`)
                ) {
                  tempSubmit();
                }
              }}
            >
              Save Draft
            </button>
          )}
        </form>
      </FormProvider>
    </>

  );
};

export default VehicleDetails;
